import { AlertBox, Icon } from '@iwoca/orion';
import { Trans } from '@lingui/react/macro';

import styles from './TrueLayerAlertBox.module.css';

const TrueLayerAlertBox = ({ status }: { status: string }) => {
  if (status === 'success') {
    return (
      <AlertBox
        variant={status}
        className={styles.alertBox}
        data-testid="alertbox"
      >
        <Icon
          width={20}
          height={20}
          icon="checkCircleFilled"
          className={styles.successAlertBoxIcon}
        />
        <span>
          <Trans>Your TrueLayer account has been linked successfully!</Trans>
        </span>
      </AlertBox>
    );
  }
  if (status === 'cancel') {
    return (
      <AlertBox
        variant={status}
        className={styles.alertBox}
        data-testid="alertbox"
      >
        <Icon
          width={20}
          height={20}
          icon="banOutline"
          className={styles.cancelAlertBoxIcon}
        />
        <span>
          <span className={styles.bold}>
            <Trans>We didn’t get your permission to link your account.</Trans>
          </span>
        </span>
      </AlertBox>
    );
  }

  return (
    <AlertBox
      variant="failure"
      className={styles.alertBox}
      data-testid="alertbox"
    >
      <Icon
        width={20}
        height={20}
        icon="exclamationTriangleOutline"
        className={styles.failureAlertBoxIcon}
      />

      <span className={styles.bold}>
        <Trans>
          Something went wrong while linking your TrueLayer account. Try again.
        </Trans>
      </span>
    </AlertBox>
  );
};

export default TrueLayerAlertBox;
